module.exports = __webpack_public_path__ + "static/media/shape0_1.530d251b.obj";